// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as PartnerPenaltyRepo from "./PartnerPenaltyRepo.bs.js";
import * as DummyPartnerPenaltyRepo from "./DummyPartnerPenaltyRepo.bs.js";

function getPartnerPenaltyRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyPartnerPenaltyRepo.PartnerPenaltyRepo;
  } else {
    return PartnerPenaltyRepo.PartnerPenaltyRepo;
  }
}

export {
  getPartnerPenaltyRepo ,
  
}
/* Config Not a pure module */
